// extracted by mini-css-extract-plugin
export default {"input":"_9SS4k","wrapper":"xvzKq","checkbox":"_45iCg","label":"wJpcQ"};